import { useState } from 'react';
import {
  ILineResource,
  IMusselLineResource,
  IOysterLineResource,
  ISeaweedLineResource,
} from '../../../entities/farms.entities';
import MusselAssessModal from './MusselAssessModal';
import OysterAssessModal from './OysterAssessModal';
import SeaweedAssessModal from './SeaweedAssessModal';
import { AreaClosedConfirmModal } from '../../CommonViews';

interface Props {
  visible: boolean;
  title?: string;
  onCancel: () => void;
  onConfirm: (data: any) => void;
  data?: any;
  lineData: ILineResource;
  updateID?: number;
  onlyView?: boolean;
  overConfirm?: (data: any) => void; // only for MUSSEL
  lineChangeable?: boolean; // only for MUSSEL
}

const AssessmentModal = ({
  visible,
  title,
  onCancel,
  onConfirm,
  data,
  lineData,
  updateID,
  onlyView,
  overConfirm,
  lineChangeable,
}: Props) => {
  const [isConfirmed, setIsConfirmed] = useState(false);

  if (!onlyView && !isConfirmed) {
    return (
      <AreaClosedConfirmModal
        farmId={lineData.farm_id}
        onCancel={onCancel}
        onConfirm={() => setIsConfirmed(true)}
      />
    );
  }
  return (
    <>
      {lineData.crop_type === 'MUSSEL' ? (
        <MusselAssessModal
          visible={visible}
          title={title}
          onCancel={onCancel}
          onConfirm={onConfirm}
          data={data}
          lineData={lineData as IMusselLineResource}
          updateID={updateID}
          onlyView={onlyView}
          overConfirm={overConfirm}
          lineChangeable={lineChangeable}
        />
      ) : lineData.crop_type === 'OYSTER' ? (
        <OysterAssessModal
          visible={visible}
          title={title}
          onCancel={onCancel}
          onConfirm={onConfirm}
          data={data}
          lineData={lineData as IOysterLineResource}
          updateID={updateID}
          onlyView={onlyView}
          lineChangeable={lineChangeable}
          overConfirm={overConfirm}
        />
      ) : (
        <SeaweedAssessModal
          visible={visible}
          title={title}
          onCancel={onCancel}
          onConfirm={onConfirm}
          data={data}
          lineData={lineData as ISeaweedLineResource}
          updateID={updateID}
          onlyView={onlyView}
        />
      )}
    </>
  );
};

export default AssessmentModal;
